<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>

  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Parent integration details"></aw-bread-crumb>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Parent Integration Details'"
    [altColor]="false"
    [actions]="headerButtonActions()"
  >
  </aw-divider>

  <div class="info-container">
    <div>
      @for (item of parentIntegrationInfoDividers(); track $index) {
      <div class="inset">
        <span class="inset-title">{{ item.title }}</span>
        <span class="inset-info">{{ item.info }}</span>
      </div>
      <aw-divider></aw-divider>
      }
    </div>

    <div class="divider-container">
      @for (item of parentIntegrationDateDividers(); track $index) {
      <div class="inset">
        <span class="inset-title">{{ item.title }}</span>
        <span class="inset-info">{{ item.info }}</span>
      </div>
      <aw-divider></aw-divider>
      }
    </div>

    <div class="integrations-container">
      <aw-divider
        [inset]="false"
        [middleInset]="false"
        [subTitle]="'Integration Partners'"
        [altColor]="true"
      >
      </aw-divider>

      <div class="table-form-container" [ngClass]="container_theme()">
        <div>
          <aw-search
            [(ngModel)]="integrationSearchValue"
            (ngModelChange)="onSearchTable(integrationSearchValue)"
            ariaLabel="search-menu"
            [placeholder]="'Search'"
          >
            <mat-icon [svgIcon]="'search'" position="prefix"></mat-icon>
          </aw-search>
        </div>

        @if (organization === 'assetworks-employee' && userPermissions['canEdit']) {
        <Button
          AwButton
          [disable]="disableIntegrationChangeStatus"
          (click)="openChangeIntegrationStatus = true"
        >Change Status</Button>
        <Button
          AwButton
          [disable]="disableIntegrationAssociate"
          (click)="openAssociateIntegrationDialog = true"
        >Associate</Button>
        }
      </div>

      <aw-table
        [columnsDefinition]="integrationsColumnsDefinition"
        [tableData]="integrationsTableData()"
        [sortDisabled]="false"
        (checkboxList)="checkBoxActionHandler($event)"
      >
      </aw-table>

      <aw-dialog
        [visible]="openDisassociateIntegrationDialogSingle"
        [dialogOptions]="dialogOptionsDisassociateSingle"
        (primaryAction)="disassociateIntegrationFormSubmit()"
        (secondaryAction)="dialogFormCloseHandler('disassociate')"
        ariaLabel="Disassociate integration partner"
      >
      </aw-dialog>

      <aw-dialog
        [visible]="openChangeIntegrationStatus"
        [formFieldsData]="changeStatusFormFields()"
        [dialogOptions]="dialogOptionsChangeStatus"
        (primaryAction)="changeIntegrationStatusFormSubmit($event)"
        (secondaryAction)="dialogFormCloseHandler('change-status')"
        ariaLabel="Change integration partner status"
      >
      </aw-dialog>

      <aw-dialog
        [visible]="openAssociateIntegrationDialog"
        [dialogOptions]="dialogOptionsAssociate"
        (primaryAction)="associateIntegrationsFormSubmit()"
        (secondaryAction)="dialogFormCloseHandler('associate')"
        ariaLabel="Associate integration partners"
      >
      </aw-dialog>
    </div>
  </div>
</div>
